<template>
    <div class="modal fade show" style="display: block;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">评价</h4>
                    <button type="button" class="close" @click="closeModal()">×</button>
                </div>
                <div class="modal-body">
                    <el-form>
                        <el-row :gutter="20">
                            <el-form-item label="评价">
                                <el-input v-model="studentEvaluation.evaluation" size="small"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row :gutter="20">
                            <el-form-item label="评分">
                                <el-input v-model="studentEvaluation.score" size="small"></el-input>
                            </el-form-item>
                        </el-row>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" size="small" @click="handleAddStudentEvaluation()"
                                   :loading="button_loading">新 增
                        </el-button>
                        <el-button type="primary" size="small" @click="handleUpdateStudentEvaluation()"
                                   :loading="button_loading">修 改
                        </el-button>
                        <el-button type="primary" size="small" @click="modalClose()">退 出</el-button>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialogs -->
    </div>
</template>

<script>
    export default {
        name: "Dialog_StudentCourseEvaluation",
        data() {
            return {
                path: 'student/info',
                button_loading: false,
                studentEvaluation: '',
            };
        },
        created() {
            this.handleCreate();
            this.handelShowStudentEvaluation();
        },
        mounted() {

        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'showStudentEvaluation':
                        this.studentEvaluation = data.studentEvaluation;
                        break;
                    case 'addStudentEvaluation':
                        this.$message({
                            message: '评价成功',
                            type: 'success'
                        });
                        this.button_loading = false;
                        break;
                    case 'addStudentEvaluationError':
                        this.button_loading = false;
                        break;
                    case 'updateStudentEvaluation':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.button_loading = false;
                        this.closeModal();
                        break;
                    case 'updateStudentEvaluationError':
                        this.button_loading = false;
                        break;
                }
            },
            //查找该课程评价
            handelShowStudentEvaluation() {
                this.$wApi.send(this.path, 'showStudentEvaluation', {
                    'studentPeriod_id': this.$route.params.studentPeriod_id,

                });
                // this.$axios.get(store.state.server + '/studentInformation/evaluation?studentPeriod_id=' + this.$route.params.studentPeriod_id
                //     +'&'+localStorage.baseUrl).then((response) => {
                //     if (response.data.status == 'success') {
                //         this.studentEvaluation = response.data.data.studentEvaluation;
                //     }
                // })
            },
            //新建评价
            handleAddStudentEvaluation() {
                this.button_loading = true;
                this.$wApi.send(this.path, 'addStudentEvaluation', {
                    'student_id': this.$route.query.student_id,
                    'course_id': this.studentEvaluation.course_id,
                    'class_id': this.studentEvaluation.class_id,
                    'score': this.studentEvaluation.score,
                    'evaluation': this.studentEvaluation.evaluation,

                });
                // this.$axios.post(store.state.server + '/studentInformation/evaluation'+'?'+localStorage.baseUrl, {
                //     'student_id': this.$route.query.student_id,
                //     'course_id': this.studentEvaluation.course_id,
                //     'class_id': this.studentEvaluation.class_id,
                //     'score':this.studentEvaluation.score,
                //     'evaluation':this.studentEvaluation.evaluation
                // }).then((response) => {
                //     if (response.status !='200'){
                //         this.button_loading=false;
                //     }
                //     if (response.data.status == 'success') {
                //         this.$message({
                //             message: '评价成功',
                //             type: 'success'
                //         });
                //         this.button_loading=false;
                //     } else if (response.data.status == 'error') {
                //         this.$message.error(response.data.msg)
                //         this.button_loading=false;
                //     }
                // })
            },
            //修改评价
            handleUpdateStudentEvaluation() {
                this.button_loading = true;
                this.$wApi.send(this.path, 'updateStudentEvaluation', {
                    'id': this.studentEvaluation.id,
                    'student_id': this.$route.query.student_id,
                    'score': this.studentEvaluation.score,
                    'evaluation': this.studentEvaluation.evaluation,

                });
                // this.$axios.put(store.state.server + '/studentInformation/evaluation/' + this.studentEvaluation.id + '?' + localStorage.baseUrl, {
                //     'student_id': this.$route.query.student_id,
                //     'score': this.studentEvaluation.score,
                //     'evaluation': this.studentEvaluation.evaluation
                // }).then((response) => {
                //     if (response.status != '200') {
                //         this.button_loading = false;
                //     }
                //     if (response.data.status == 'success') {
                //         this.$message({
                //             message: '修改成功',
                //             type: 'success'
                //         });
                //         this.button_loading = false;
                //         this.closeModal();
                //     }
                // })
            },
            closeModal() {
                this.$store.commit('modal', {dialog: ''});
            },
        }
    };
</script>

<style scoped>

</style>